module.exports = __webpack_public_path__ + "img/pålestikk_double1.5b6f4d5a.jpg";